import React, { useEffect, useCallback } from 'react'
import { mappingService } from '../services/mappingService'

export const useGetMapping = (mondayAccountId: number, setMapping: React.Dispatch<React.SetStateAction<Mapping | undefined>>, accessToken: string | undefined): void => {
  const getMapping = useCallback(
    async (accessToken: string) => {
      const mapping: Mapping | undefined = await mappingService.getMapping(mondayAccountId!, accessToken)
      setMapping(mapping)
    },
    [mondayAccountId, setMapping]
  )

  useEffect(() => {
    mondayAccountId && accessToken && getMapping(accessToken)
  }, [mondayAccountId, accessToken, getMapping])
}
